// 这里事件id
var operations = {
  //login
  /**
   * 退出
   */
  eLogout: 'logout',
  /**
   * 刷新token
   */
  eRefreshToken: 'refreshToken',
  /**
   * 获取用户信息
   */
  eFetchUserInfo: 'fetchUserInfo',

  //设置Timer
  eSetTimer: 'SetTimer',

  //fs
  /**
   * 获取文件token
   */
  eFetchFSToken: 'fetchFSToken',
  /**
   * 上传文件
   */
  ePutFS: 'putFS',
  /**
   * 上传文件列表
   */
  ePutFSList: 'putFSList',
  /**
   * 删除文件
   */
  eDelFS: 'delFS',

  //app
  /**
 * 根据角色创建底部按钮
 */
  eCreateBottomsByRoles: 'createBottomsByRoles',
  /**
   * 根据角色选择页面
   */
  eSelectPageByRole: 'selectPageByRole',
  /**
   * 根据角色获取权限
   */
  eMapRightsFromRoles: 'mapRightsFromRoles',
  /**
   * 切换页面
   */
  eChangePage: 'changePage',
  /**
   * 获取百度语音token
   */
  eFetchTTSToken: 'fetchTTSToken',
  /**
   * APK版本升级检查
   */
  eCheckAPKUpdate: 'checkAPKUpdate',
  /**
   * 申请Android系统文件读写权限
   */
  eRequestPermissions: 'requestPermissions',
  /**
   * 解密并打开文件
   */
  eEdsFileView: 'edsFileView',


  // router
  /**
   * 返回上一页
   */
  eRouterBack: 'routerBack',
  /**
   * 替换页面(不会在history里留记录)
   */
  eRouterReplace: 'routerReplace',

  //init JPush
  /**
   * 初始化极光推送
   */
  eInitJPush: 'initJPush',
  /**
   * 设置极光推送别名(现在是用户id)
   */
  eSetJPushAlias: 'setJPushAlias',
  /**
   * 删除极光推送别名
   */
  eDeleteJPushAlias: 'deleteJPushAlias',
  /**
   * 设置极光推送标签(现在是用户角色)
   */
  eSetJPushTags: 'setJPushTags',
  /**
   * 设置安卓端收到通知的回调事件
   */
  eSetRecieveNotificationInAndroidCallback:
    'setRecieveNotificationInAndroidCallback',
  /**
   * 设置安卓端收到消息的回调事件(传递的参数应该在这里处理)
   */
  eSetRecieveMessageInAndroidCallback: 'setRecieveMessageInAndroidCallback',
  /**
   * 设置打开通知时触发的事件
   */
  eOpenNotificationInAndroidCallback: 'openNotificationInAndroidCallback',

  //msgbox
  /**
   * 设置未处理的消息数量
   */
  eFetchMsgForBoxBadge: 'fetchMsgForBoxBadge',

}

export default operations
